import type { StartupPreparationState } from '../app/startup-preparation'

interface StartupLoadingScreenProps {
  state: Exclude<StartupPreparationState, 'ready'> | 'arming'
  onRetry: () => void
}

export function StartupLoadingScreen({ state, onRetry }: StartupLoadingScreenProps) {
  const failed = state === 'failed'
  const arming = state === 'arming'
  return (
    <section
      className={`startup-loading-screen startup-loading-screen--${state}`}
      role={failed ? 'alert' : 'status'}
      aria-label={failed ? 'Night grid preparation failed' : arming ? 'Arming race systems' : 'Preparing night grid'}
      aria-live={failed ? 'assertive' : 'polite'}
    >
      <div className="startup-loading-panel">
        <p className="eyebrow">{'PROTOCOL 03 // PRE-RACE LINK'}</p>
        <h2>{failed ? 'NIGHT GRID PREPARATION FAILED' : arming ? 'ARMING RACE SYSTEMS' : 'PREPARING NIGHT GRID'}</h2>
        <p className="startup-loading-copy">
          {failed
            ? 'The renderer could not finish its pre-race checks.'
            : arming
              ? 'Synchronizing camera, audio, and race telemetry.'
              : 'Compiling the circuit before ignition.'}
        </p>
        {failed ? (
          <button className="primary-button" type="button" onClick={onRetry}>
            Retry preparation
          </button>
        ) : (
          <div className="startup-loading-track" aria-hidden="true">
            <span />
          </div>
        )}
      </div>
    </section>
  )
}
